export const pressCardComponent = {
  key: 'pressCardComponent',
  name: 'Press Card Dept-Component',
  siteIdentifier: 'global',

  readMoreButton: 'Read More',
};
